import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="w-10 h-10 rounded-full transition-smooth glass-effect flex items-center justify-center"
      style={{ borderColor: 'rgba(249, 115, 22, 0.3)' }}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun size={18} style={{ color: '#F97316' }} />
      ) : (
        <Moon size={18} style={{ color: '#F97316' }} />
      )}
    </button>
  );
};

export default ThemeToggle;
